import React, {useEffect} from 'react'
import TickIcon from '../Common-components/TickIcon'
import {Link, useParams} from 'react-router-dom'
import Header from '../Common-components/Header'
import Footer from '../Common-components/Footer'
import Advertise from '../Common-components/Advertise'
import BannerBackgroundLeft from '../../Assets/backgrount-left.png'
import BannerBackground from '../../Assets/background.png'

const Mosabaqa = () => {
	const params = useParams();


	return (
		<div>

		</div>
	)
}

export default Mosabaqa